// Code generated by protoc-gen-family-http. DO NOT EDIT.
// source: todo.proto

import type { AxiosInstance } from 'axios';
import { buildPath, unwrapEnvelope, Envelope } from '../contracts-runtime';
import { Empty } from "./google/protobuf/empty";
import { BriefResponse, CancelScheduledCompleteTodoRequest, ClaimTodoRequest, CompleteCurrentInSeriesRequest, CompleteCurrentInSeriesResponse, CompleteTodoRequest, CreateTodoRequest, DeleteTodoRequest, GetTodoRequest, ListCompletionsRequest, ListTodosRequest, MarkBlockedTodoRequest, MarkBlockedTodoResponse, MoveTodoRequest, RecurringSeriesListResponse, ScheduleCompleteResponse, ScheduleCompleteTodoRequest, SkipTodoRequest, SmartTodoRequest, SmartTodoResponse, SnoozeTodoRequest, TagListResponse, Todo, TodoCompletion, TodoCompletionListResponse, TodoCompletionSyncPullRequest, TodoCompletionSyncPullResponse, TodoListResponse, TodoSyncPullRequest, TodoSyncPullResponse, TodoSyncPushRequest, TodoSyncPushResponse, UnblockTodoRequest, UnblockTodoResponse, UpdateCompletionPathRequest, UpdateTodoPathRequest, UpdateTodoResponse } from "./todo";

// ─── TodoService ──────────────────────────────────

export const TodoService_SmartTodoRoute = "POST /api/v1/todos/smart";
export const TodoService_ListCompletionsRoute = "GET /api/v1/todos/completions";
export const TodoService_UpdateCompletionRoute = "PATCH /api/v1/todos/completions/{id}";
export const TodoService_CreateTodoRoute = "POST /api/v1/todos";
export const TodoService_GetTodoRoute = "GET /api/v1/todos/{id}";
export const TodoService_ListTodosRoute = "GET /api/v1/todos";
export const TodoService_UpdateTodoRoute = "PATCH /api/v1/todos/{id}";
export const TodoService_UpdateTodoRoute_Alias1 = "PUT /api/v1/todos/{id}";
export const TodoService_DeleteTodoRoute = "DELETE /api/v1/todos/{id}";
export const TodoService_CompleteTodoRoute = "POST /api/v1/todos/{id}/complete";
export const TodoService_ListRecurringSeriesRoute = "GET /api/v1/todos/series";
export const TodoService_CompleteCurrentInSeriesRoute = "POST /api/v1/todos/series/{series_id}/complete-current";
export const TodoService_ScheduleCompleteTodoRoute = "POST /api/v1/todos/{id}/schedule-complete";
export const TodoService_CancelScheduledCompleteTodoRoute = "DELETE /api/v1/todos/{id}/schedule-complete";
export const TodoService_SnoozeTodoRoute = "POST /api/v1/todos/{id}/snooze";
export const TodoService_SkipTodoRoute = "POST /api/v1/todos/{id}/skip";
export const TodoService_ClaimTodoRoute = "POST /api/v1/todos/{id}/claim";
export const TodoService_MoveTodoRoute = "POST /api/v1/todos/{id}/move";
export const TodoService_MarkBlockedTodoRoute = "POST /api/v1/todos/{id}/mark-blocked";
export const TodoService_UnblockTodoRoute = "POST /api/v1/todos/{id}/unblock";
export const TodoService_SyncPushTodosRoute = "POST /api/v1/todos/sync/push";
export const TodoService_SyncPullTodosRoute = "POST /api/v1/todos/sync/pull";
export const TodoService_SyncPullCompletionsRoute = "POST /api/v1/todos/completions/sync/pull";
export const TodoService_ListTagsRoute = "GET /api/v1/tags";

export const todoService = {
  async smartTodo(client: AxiosInstance, req: SmartTodoRequest): Promise<SmartTodoResponse> {
    const path = buildPath("/api/v1/todos/smart", {});
    const res = await client.post<Envelope<unknown>>(path, SmartTodoRequest.toJSON(req));
    return SmartTodoResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async listCompletions(client: AxiosInstance, req: ListCompletionsRequest): Promise<TodoCompletionListResponse> {
    const path = buildPath("/api/v1/todos/completions", {});
    const res = await client.get<Envelope<unknown>>(path, { params: ListCompletionsRequest.toJSON(req) });
    return TodoCompletionListResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async updateCompletion(client: AxiosInstance, req: UpdateCompletionPathRequest): Promise<TodoCompletion> {
    const path = buildPath("/api/v1/todos/completions/{id}", { id: String(req.id) });
    const res = await client.patch<Envelope<unknown>>(path, UpdateCompletionPathRequest.toJSON(req));
    return TodoCompletion.fromJSON(unwrapEnvelope(res.data));
  },
  async createTodo(client: AxiosInstance, req: CreateTodoRequest): Promise<Todo> {
    const path = buildPath("/api/v1/todos", {});
    const res = await client.post<Envelope<unknown>>(path, CreateTodoRequest.toJSON(req));
    return Todo.fromJSON(unwrapEnvelope(res.data));
  },
  async getTodo(client: AxiosInstance, req: GetTodoRequest): Promise<Todo> {
    const path = buildPath("/api/v1/todos/{id}", { id: String(req.id) });
    const res = await client.get<Envelope<unknown>>(path, { params: GetTodoRequest.toJSON(req) });
    return Todo.fromJSON(unwrapEnvelope(res.data));
  },
  async listTodos(client: AxiosInstance, req: ListTodosRequest): Promise<TodoListResponse> {
    const path = buildPath("/api/v1/todos", {});
    const res = await client.get<Envelope<unknown>>(path, { params: ListTodosRequest.toJSON(req) });
    return TodoListResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async updateTodo(client: AxiosInstance, req: UpdateTodoPathRequest): Promise<UpdateTodoResponse> {
    const path = buildPath("/api/v1/todos/{id}", { id: String(req.id) });
    const res = await client.patch<Envelope<unknown>>(path, UpdateTodoPathRequest.toJSON(req));
    return UpdateTodoResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async deleteTodo(client: AxiosInstance, req: DeleteTodoRequest): Promise<Empty> {
    const path = buildPath("/api/v1/todos/{id}", { id: String(req.id) });
    const res = await client.delete<Envelope<unknown>>(path, { params: DeleteTodoRequest.toJSON(req) });
    return Empty.fromJSON(unwrapEnvelope(res.data));
  },
  async completeTodo(client: AxiosInstance, req: CompleteTodoRequest): Promise<Todo> {
    const path = buildPath("/api/v1/todos/{id}/complete", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, CompleteTodoRequest.toJSON(req));
    return Todo.fromJSON(unwrapEnvelope(res.data));
  },
  async listRecurringSeries(client: AxiosInstance, req: Empty): Promise<RecurringSeriesListResponse> {
    const path = buildPath("/api/v1/todos/series", {});
    const res = await client.get<Envelope<unknown>>(path, { params: Empty.toJSON(req) });
    return RecurringSeriesListResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async completeCurrentInSeries(client: AxiosInstance, req: CompleteCurrentInSeriesRequest): Promise<CompleteCurrentInSeriesResponse> {
    const path = buildPath("/api/v1/todos/series/{series_id}/complete-current", { series_id: String(req.series_id) });
    const res = await client.post<Envelope<unknown>>(path, CompleteCurrentInSeriesRequest.toJSON(req));
    return CompleteCurrentInSeriesResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async scheduleCompleteTodo(client: AxiosInstance, req: ScheduleCompleteTodoRequest): Promise<ScheduleCompleteResponse> {
    const path = buildPath("/api/v1/todos/{id}/schedule-complete", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, ScheduleCompleteTodoRequest.toJSON(req));
    return ScheduleCompleteResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async cancelScheduledCompleteTodo(client: AxiosInstance, req: CancelScheduledCompleteTodoRequest): Promise<Empty> {
    const path = buildPath("/api/v1/todos/{id}/schedule-complete", { id: String(req.id) });
    const res = await client.delete<Envelope<unknown>>(path, { params: CancelScheduledCompleteTodoRequest.toJSON(req) });
    return Empty.fromJSON(unwrapEnvelope(res.data));
  },
  async snoozeTodo(client: AxiosInstance, req: SnoozeTodoRequest): Promise<Todo> {
    const path = buildPath("/api/v1/todos/{id}/snooze", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, SnoozeTodoRequest.toJSON(req));
    return Todo.fromJSON(unwrapEnvelope(res.data));
  },
  async skipTodo(client: AxiosInstance, req: SkipTodoRequest): Promise<Todo> {
    const path = buildPath("/api/v1/todos/{id}/skip", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, SkipTodoRequest.toJSON(req));
    return Todo.fromJSON(unwrapEnvelope(res.data));
  },
  async claimTodo(client: AxiosInstance, req: ClaimTodoRequest): Promise<Todo> {
    const path = buildPath("/api/v1/todos/{id}/claim", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, ClaimTodoRequest.toJSON(req));
    return Todo.fromJSON(unwrapEnvelope(res.data));
  },
  async moveTodo(client: AxiosInstance, req: MoveTodoRequest): Promise<Todo> {
    const path = buildPath("/api/v1/todos/{id}/move", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, MoveTodoRequest.toJSON(req));
    return Todo.fromJSON(unwrapEnvelope(res.data));
  },
  async markBlockedTodo(client: AxiosInstance, req: MarkBlockedTodoRequest): Promise<MarkBlockedTodoResponse> {
    const path = buildPath("/api/v1/todos/{id}/mark-blocked", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, MarkBlockedTodoRequest.toJSON(req));
    return MarkBlockedTodoResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async unblockTodo(client: AxiosInstance, req: UnblockTodoRequest): Promise<UnblockTodoResponse> {
    const path = buildPath("/api/v1/todos/{id}/unblock", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, UnblockTodoRequest.toJSON(req));
    return UnblockTodoResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async syncPushTodos(client: AxiosInstance, req: TodoSyncPushRequest): Promise<TodoSyncPushResponse> {
    const path = buildPath("/api/v1/todos/sync/push", {});
    const res = await client.post<Envelope<unknown>>(path, TodoSyncPushRequest.toJSON(req));
    return TodoSyncPushResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async syncPullTodos(client: AxiosInstance, req: TodoSyncPullRequest): Promise<TodoSyncPullResponse> {
    const path = buildPath("/api/v1/todos/sync/pull", {});
    const res = await client.post<Envelope<unknown>>(path, TodoSyncPullRequest.toJSON(req));
    return TodoSyncPullResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async syncPullCompletions(client: AxiosInstance, req: TodoCompletionSyncPullRequest): Promise<TodoCompletionSyncPullResponse> {
    const path = buildPath("/api/v1/todos/completions/sync/pull", {});
    const res = await client.post<Envelope<unknown>>(path, TodoCompletionSyncPullRequest.toJSON(req));
    return TodoCompletionSyncPullResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async listTags(client: AxiosInstance, req: Empty): Promise<TagListResponse> {
    const path = buildPath("/api/v1/tags", {});
    const res = await client.get<Envelope<unknown>>(path, { params: Empty.toJSON(req) });
    return TagListResponse.fromJSON(unwrapEnvelope(res.data));
  },
};

// ─── BriefService ──────────────────────────────────

export const BriefService_GetBriefRoute = "GET /api/v1/brief";
export const BriefService_GetBriefTodayRoute = "GET /api/v1/brief/today";

export const briefService = {
  async getBrief(client: AxiosInstance, req: Empty): Promise<BriefResponse> {
    const path = buildPath("/api/v1/brief", {});
    const res = await client.get<Envelope<unknown>>(path, { params: Empty.toJSON(req) });
    return BriefResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async getBriefToday(client: AxiosInstance, req: Empty): Promise<BriefResponse> {
    const path = buildPath("/api/v1/brief/today", {});
    const res = await client.get<Envelope<unknown>>(path, { params: Empty.toJSON(req) });
    return BriefResponse.fromJSON(unwrapEnvelope(res.data));
  },
};

